import type { AdminUser } from '@/types/api';

/** What an admin console area needs: a module key, or super-admin only. */
export type AdminAreaAccess = {
  /** Module key required (super admins always pass). */
  module?: string;
  /** Super admins only. */
  superOnly?: boolean;
};

/**
 * One rule for both the sidebar and the route guards, mirroring the server
 * (`HasAdminModule` / `IsSuperAdmin` in tally-backend admin/permissions.py).
 */
export function canAccessAdminArea(
  admin: Pick<AdminUser, 'is_superuser' | 'module_access'> | null | undefined,
  { module, superOnly }: AdminAreaAccess,
): boolean {
  if (admin?.is_superuser) return true;
  if (superOnly) return false;
  if (module) return Boolean(admin?.module_access?.[module]);
  return true;
}
